module.exports = __webpack_public_path__ + "images/business-stories-stockimage-1.png";